import React, { useContext, useEffect, useState } from "react";
import Input from "../../../stories/Input/Input";
import JunctionImage from "../../../images/ItemIcons/junction.svg";
import Arrow from "../../../images/ArrowRight.svg";
import { CustomDrawerInMobile } from "../../../styles/CustomDrawerStyles";
import FollowUpStatus from "./FollowUpStatus";
import { useLazyQuery } from "@apollo/client";
import {
  GetTransformTicketsResult,
  GetTransformTicketsVar,
  PriorityType,
} from "./queries/types";
import { GetTransformTickets } from "./queries/queries";
import { OrderDirection } from "../../../utils/commonQueryTypes";
import { AtsTicketsOrderField } from "../../../queries/types";
import { convertToTimeZone } from "../../../utils/UtilFunctions";
import { TimeZone } from "../../../utils/Enum.types";
import { AppContext } from "../../../context/context";
import { payloadTypes } from "../../../context/reducer";
import useServerDateandTimeWithoutToken from "../../../customHooks/useServerDateandTimeWithoutToken";
import { ROWS_PER_PAGE } from "../../../utils/constants";
import LoadingModal from "../../pages/LoadingModal";

const OpenTickets = () => {
  const {
    serverDate,
    data: serverData,
    loading: serverLoading,
  } = useServerDateandTimeWithoutToken();
  const [followUpStatus, setFollowUpStatus] = useState(false);
  const [searchData, setSearchData] = useState("");
  const { dispatch } = useContext(AppContext);

  const [getTransformTickets, { data, loading: getTicketLoading }] =
    useLazyQuery<GetTransformTicketsResult, GetTransformTicketsVar>(
      GetTransformTickets
    );

  useEffect(() => {
    getTransformTickets({
      variables: {
        after: null,
        first: ROWS_PER_PAGE,
        name: searchData,
        orderBy: {
          direction: OrderDirection.DESC,
          field: AtsTicketsOrderField.CREATED_AT,
        },
      },
    });
  }, [getTransformTickets, searchData]);

  const getAging = (date: string) => {
    if (serverData && !serverLoading) {
      const presentDate = new Date(serverDate);
      const ticketDate = new Date(date);

      const diffMs = Math.abs(ticketDate.getTime() - presentDate.getTime()); // Absolute difference in ms

      const diffSec = Math.floor(diffMs / 1000); // Total seconds
      const diffMin = Math.floor(diffSec / 60); // Total minutes
      const diffHours = Math.floor(diffMin / 60); // Total hours
      const diffDays = Math.floor(diffHours / 24); // Total days

      const remainingHours = diffHours % 24; // Hours excluding full days
      const remainingMinutes = diffMin % 60; // Minutes excluding full hours
      const remainingSeconds = diffSec % 60; // Seconds excluding full minutes

      let result = "";
      if (diffDays) result += `${diffDays} days `;
      if (remainingHours) result += `${remainingHours} hrs `;
      if (remainingMinutes) result += `${remainingMinutes} mins `;
      if (remainingSeconds) result += `${remainingSeconds} secs`;

      return result.trim(); // Remove extra spaces
    }
    return "";
  };

  return (
    <div className="mobile-active-tickets">
      <Input
        id="data_search"
        placeholder="Search..."
        onChange={(e) => {
          setSearchData(e.target.value);
        }}
      />

      <div className="mobile-active-tickets__block">
        <ul>
          {data
            ? data.GetTransformTickets.edges.map(({ node }, index) => {
                return (
                  <li
                    className={
                      node.priority === PriorityType.CRITICAL
                        ? "border-red"
                        : node.priority === PriorityType.MEDIUM
                        ? "border-yellow"
                        : node.priority === PriorityType.LOW
                        ? "border-green"
                        : ""
                    }
                    onClick={() => {
                      setFollowUpStatus(!followUpStatus);
                      dispatch({
                        type: payloadTypes.SET_COMPANY_ID,
                        payload: {
                          companyId: node.companyID,
                        },
                      });
                      dispatch({
                        type: payloadTypes.SET_JUNCTION_ID,
                        payload: {
                          junctionID: node.junctionID,
                        },
                      });
                    }}
                  >
                    <div className="mobile-active-tickets__block--flex">
                      <div className="mobile-raise-ticket__junctions">
                        <div className="mobile-raise-ticket__junctions--h">
                          <div className="mobile-raise-ticket__junctions--h--flex">
                            <img src={JunctionImage} alt="" />
                            <div>
                              <b className="mobile-raise-ticket__junctions--h--item">
                                {node.junction.name}
                              </b>
                              <span> {node.junction.code}</span>

                              <div className="mobile-raise-ticket__junctions--h--span">
                                <span>Alias : {node.junction.alias}</span>
                                <span>
                                  Vendor Name :{" "}
                                  {node.junction.vendorDetails.desc}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mobile-active-tickets__block--tkt-details">
                        <span>Ticket No.</span>
                        <span>:</span>
                        <b className="mobile-active-tickets__block--font-red">
                          {node.ticketNo}
                        </b>
                      </div>
                      <div className="mobile-active-tickets__block--tkt-details">
                        <span>Ticket Date</span>
                        <span>:</span>
                        <b>
                          {
                            convertToTimeZone(
                              TimeZone.Asia_Kolkata,
                              node.ticketDate
                            ).date
                          }{" "}
                          <span className="font-grey">
                            {
                              convertToTimeZone(
                                TimeZone.Asia_Kolkata,
                                node.ticketDate
                              ).time
                            }
                          </span>
                        </b>
                      </div>
                      <div className="mobile-active-tickets__block--tkt-details">
                        <span>Maintained By</span>
                        <span>:</span>
                        <b>{node.vendorDetails.desc}</b>
                      </div>
                      <div className="mobile-active-tickets__block--tkt-details">
                        <span>Ticket Reason</span>
                        <span>:</span>
                        <b>{node.reason}</b>
                      </div>
                      <div className="mobile-active-tickets__block--tkt-details">
                        <span>Ageing</span>
                        <span>:</span>
                        <b>{getAging(node.ticketDate)}</b>
                      </div>
                      <div className="mobile-active-tickets__block--tkt-details">
                        <span>Assigned To</span>
                        <span>:</span>
                        <b>{node.assignedUser.name}</b>
                      </div>
                    </div>

                    <img
                      src={Arrow}
                      alt=""
                      style={{ filter: "invert(100%)" }}
                      className="mobile-active-tickets__block--arrrow"
                    />
                  </li>
                );
              })
            : null}
        </ul>
      </div>

      <CustomDrawerInMobile
        anchor="bottom"
        open={followUpStatus}
        onClose={() => setFollowUpStatus(!followUpStatus)}
      >
        <FollowUpStatus setModal={setFollowUpStatus} />
      </CustomDrawerInMobile>
      <LoadingModal flag={getTicketLoading} message="Fetching..." forMobile={true} />
    </div>
  );
};

export default OpenTickets;
